module.exports = __webpack_public_path__ + "img/logo.1cd232d8.svg";